export const INVOICES_STATUS = {
  underAnalysis: 0,
  released: 1,
  disqualified: 2,
  awaitingApproval: 3,
};
